import { render } from "./ValuesSectionItem.vue?vue&type=template&id=53c758f5"
import script from "./ValuesSectionItem.vue?vue&type=script&lang=js"
export * from "./ValuesSectionItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__